import styled, { css } from 'styled-components';

import { FadeOutDownKeyframes } from 'DesignLibrary/keyframes';

export interface OpenEnrollmentBarProps {
  isNextClicked: boolean;
  openEnrollmentStartDate: string | undefined;
  openEnrollmentEndDate: string | undefined;
}

export const EnrollBar = styled.section`
  position: fixed;
  bottom: var(--sizing-sm);
  right: var(--sizing-sm);
  max-width: calc(100% - 32px);
  z-index: var(--chakra-zIndices-banner);
`;

export const Content = styled.div<OpenEnrollmentBarProps>`
  background: var(--primary-white);
  width: 100%;
  border-radius: var(--border-radius-xs);
  box-shadow: var(--shadow-large);
  padding: var(--sizing-sm);
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 0 1rem 1rem;
  border-radius: 1rem;
  border: 2px solid #e0e0e5;

  .paragraph,
  p {
    font-weight: 700 !important;
    color: var(--colors-alex-ink);
    b {
      color: var(--text-black);
    }
  }

  .title {
    /* border: 1px solid red; */
    /* Target the number by its own class rather than the first <b>: the Contentful copy
       controls which words are bold, and depending on mark order the number may not be,
       so "first bold word" can enlarge the wrong word. */
    .days-count {
      font-size: 3.75rem;
      font-weight: 400;
      font-family: 'Gelica', Georgia, serif;
      /* The number isn't always inside a <b>, so it carries the bold-text colour itself. */
      color: var(--text-black);
    }
    button {
      position: absolute;
      top: 0.5rem;
      right: 0.5rem;
    }
  }

  .dates {
    width: 100%;
    display: flex;

    * {
      text-transform: none;
      font-size: 1rem;
      font-weight: 500;
      color: var(--colors-alex-ink80);
    }

    span span {
      margin-left: 0.25rem;
    }
  }

  ${({ isNextClicked }) =>
    isNextClicked &&
    css`
      opacity: 1;
      animation-delay: 0.75s;
      animation-name: ${FadeOutDownKeyframes};
      animation-duration: 1.25s;
    `}
`;
